<template>
    <b-container fluid class="">
        <b-container class="dashboardTile p-4 shadow-lg">
            <b-row v-if="event">
            <b-col cols="12" lg="4">
                <b-row class="py-2">
                    <b-col cols="12" class="text-center">
                        <h5>{{ $t('ticket_scan.actions') }}</h5>
                    </b-col>
                </b-row>
                <b-row class="py-2 flex-center">
                    <b-col cols="6" class="py-2">
                        <b-btn v-b-modal.editEvent class="float-right w-100"><span class="fa fa-edit mx-2"></span> {{ $t('event.buttons.edit') }}</b-btn>
                    </b-col>
                    <b-col cols="6" class="py-2">
                        <b-btn v-b-modal.deleteEvent variant="danger" class="float-right w-100"><span class="fas fa-trash-alt mx-2"></span>{{ $t('event.buttons.delete') }}</b-btn>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-btn v-b-modal.generateTickets variant="primary" class="float-right w-100"><span class="fa fa-ticket-alt mx-2"></span> {{ $t('event.buttons.generate') }}</b-btn>
                    </b-col>
                    <b-col cols="6" class="py-2">
                        <b-btn @click="testPrint" class="float-right w-100"><span class="fa fa-print mx-2"></span> {{ $t('event.buttons.test') }}</b-btn>
                    </b-col>
                    <b-col cols="6" class="py-2">
                        <b-btn v-b-modal.ticketsPrint variant="success" class="float-right w-100"><span class="fa fa-print mx-2"></span> {{ $t('event.buttons.print') }}</b-btn>
                    </b-col>
                    <b-col cols="12" class="py-2">
                        <b-btn :href="'/static/' + event.id + '.csv'"  @click="setSold()" variant="info" class="float-right w-100"><span class="fas fa-download mx-2"></span>{{ $t('event.modal.buttons.down') }}</b-btn>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" lg="8" class="d-none d-md-block">
                <b-row class="py-2">
                    <b-col cols="12" class="text-center">
                        <h5>{{ $t('ticket_scan.preview') }}</h5>
                    </b-col>
                </b-row>
                 <b-row class="py-4">
                    <b-col cols="6">
                        <h4 class="mx-4 px-4">{{event.headline_a}}</h4>
                        <h5 class="mx-4 px-4">{{event.headline_b}}</h5>
                        <h6 class="mx-4 px-4">{{event.line_a}}</h6>
                        <h6 class="mx-4 px-4">{{event.line_b}}</h6>
                    </b-col>
                    <b-col cols="4" class="text-right">
                        <h6>{{ $t('ticket_scan.sector') }} A</h6>
                        <h6>{{ $t('ticket_scan.row') }} 5</h6>
                        <h6>{{ $t('ticket_scan.seat') }} 17</h6>
                    </b-col>
                    <b-col cols="2" class="text-right">
                        <b-img :src="require('../../assets/img/barcode.png')" fluid alt="profile.png"/>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <hr/>

            <b-row class="py-4" v-if="selectedGroups.length > 0">
                <b-col cols="12">
                    <h4>{{ $t('event.inc') }}</h4>
                </b-col>
                <b-col cols="12" md="3" class="noSectorDash m-2 p-2 text-center" v-for="group in selectedGroups">
                    <h5>{{group.name}}</h5>
                </b-col>
         </b-row>
        </b-container>

        <b-container fluid class="dashboardTile my-4 p-4 shadow-lg">
            <b-row class="py-4">
            <b-col cols="12" class="w-100">
                <b-row>
                    <b-col cols="12">
                        <h4>
                            {{ $t('event.jobs') }}
                        </h4>
                    </b-col>
                </b-row>
                <b-row v-if="printJobs">
                    <b-col cols="12">
                        <events-table position
                                      search-key="name"
                                      :items="printJobs"
                                      :fields="printJobFields">
                        </events-table>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        </b-container>
        


        <b-modal centered
                 id="deleteEvent"
                 title=""
                 @ok="deleteEvent"
                 ok-variant="danger">
                 <template v-slot:modal-title>
                    {{$t('events.title.delete')}}
                </template>
            <p class="my-4">{{ $t('event.modal.msg') }}</p>
        </b-modal>



        <b-modal centered
                 no-close-on-backdrop
                 id="editEvent"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('events.title.edit')}}
                </template>
            <b-form @submit.prevent="editEvent()" data-vv-scope="editEvent">
                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="name">{{$t('events.modal.name')}}
                            <b-form-input :state="validateState('editEvent.name')"
                                          :class="{'is-invalid': veeErrors.has('editEvent.name')}"
                                          v-validate="'required|min:6'" v-model="event.name" id="name" ref="name" type="text" size="md" name="name" :placeholder="$t('placeholders.name')"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editEvent.name') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="headlineA">{{ $t('events.modal.headline.a') }}
                            <b-form-input :state="validateState('editEvent.headlineA')"
                                          :class="{'is-invalid': veeErrors.has('editEvent.headlineA')}"
                                          v-validate="'required|min:6'" v-model="event.headline_a" id="headlineA" ref="headlineA" type="text" size="md" name="headlineA" :placeholder="$t('events.modal.headline.a')"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editEvent.headlineA') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="headlineB">{{ $t('events.modal.headline.b') }}
                            <b-form-input :state="validateState('editEvent.headlineB')"
                                          :class="{'is-invalid': veeErrors.has('editEvent.headlineB')}"
                                          v-validate="'required|min:4'" v-model="event.headline_b" id="headlineB" ref="headlineB" type="text" size="md" name="headlineB" :placeholder="$t('events.modal.headline.b')"></b-form-input>
                            <span class="vvError">{{ veeErrors.first('editEvent.headlineB') }}</span>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="lineA">{{ $t('events.modal.line.a') }}
                            <b-form-input v-model="event.line_a" id="lineA" ref="lineA" type="text" size="md" name="lineA" :placeholder="$t('events.modal.line.a')" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <b-form-group label-for="lineB">{{ $t('events.modal.line.b') }}
                            <b-form-input v-model="event.line_b" id="lineB" ref="lineB" type="text" size="md" name="lineB" :placeholder="$t('events.modal.line.b')" required></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" class="text-center">
                        <b-btn type="submit" :disabled="veeErrors.any('editEvent')" ref="btnEdit" variant="primary" class="w-50">{{ $t('event.modal.buttons.confirm') }}</b-btn>
                    </b-col>
                </b-row>
            </b-form>
        </b-modal>

        <b-modal centered
                 no-close-on-backdrop
                 id="generateTickets"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('events.title.generate')}}
                </template>
            <b-col md="12">
                <b-form @submit.prevent="generateTickets()" data-vv-scope="generateTickets" v-show="generateSectors.length > 0">
                    <b-row v-show="event.with_sectors === false">
                        <b-col cols="6">
                            <b-form-group :label="$t('events.modal.not')"
                                          label-for="ticketsAmount"
                                          name="ticketsAmount">
                                <b-form-input :state="validateState('generateTickets.ticketsAmount')"
                                              :class="{'is-invalid': veeErrors.has('generateTickets.ticketsAmount')}"
                                              v-validate="event.with_sectors === false ? 'required|min_value:1':''" v-model="tickets.amount"
                                              id="ticketsAmount" ref="ticketsAmount" type="number" size="md" name="ticketsAmount"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('generateTickets.ticketsAmount') }}</span>
                            </b-form-group>
                        </b-col>
                         <b-col cols="6">
                            <b-form-group :label="$t('events.modal.type')"
                                          label-for="ticketTypeRadio"
                                          name="ticketType">
                                <b-form-radio v-model="tickets.type" name="ticketTypeRadio" default inline value="1">{{$t("events.modal.radio.paper")}}</b-form-radio>
                                <b-form-radio v-model="tickets.type" name="ticketTypeRadio" inline value="2">{{$t("events.modal.radio.rfid")}}</b-form-radio>
                            </b-form-group>
                        </b-col>
                    </b-row>
                         <b-row v-show="event.with_sectors === true">
                            <b-col cols="12" lg="6">
                                <h5 class="text-center">{{$t('events.modal.allSectors')}}</h5>
                                <b-list-group>
                                    <b-list-group-item v-show="!sector.selected" href="#" variant="secondary" @click="addSector(sector)" v-for="sector in generateSectors" v-bind:key="sector.id">
                                        {{ sector.code }}
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                            <b-col cols="12" class="d-md-none">
                                <hr/>
                            </b-col>
                            <b-col cols="12" lg="6">
                                <h5 class="flex-center">{{$t('events.modal.selectedSectors')}}</h5>
                                <b-list-group>
                                    <b-list-group-item v-show="sector.selected" href="#" variant="success" @click="removeSector(sector)" v-for="sector in generateSectors" v-bind:key="sector.id">
                                        {{ sector.code }}
                                    </b-list-group-item>
                                </b-list-group>
                            </b-col>
                         </b-row>
                        <b-row v-show="event.with_sectors === true">
                            <b-col cols="12" class="py-2 text-center">
                                <p style="font-style: italic;" >
                                    {{$t('events.modal.tip')}}
                                </p>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="6" class="text-center">
                            </b-col>
                            <b-col cols="12" lg="6" class="text-center">
                                    <b-btn type="submit" :disabled="veeErrors.any('generateTickets')" variant="primary" class="float-right w-50">{{$t('events.modal.generate')}}</b-btn>
                            </b-col>
                        </b-row>
            </b-form>
                <b-row v-show="generateSectors.length === 0">
                        <b-col cols="12">
                            <b-row class="flex-center flex-column">
                                <h4 class="text-center">
                                    {{$t('noData.sectors.msg')}}
                                </h4>
                                <p style="font-style: italic;" >
                                    {{$t('noData.sectors.tip')}}
                                </p>
                            </b-row>
                        </b-col>
                    </b-row>
            </b-col>
        </b-modal>

        <b-modal centered
                 no-close-on-backdrop
                 id="ticketsPrint"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('events.title.print')}}
                </template>
            <b-col md="12">
                <b-form @submit.prevent="ticketsPrint()" data-vv-scope="printTickets">
                    <b-row>
                        <b-col cols="6">
                            <b-form-group label-for="printName">{{ $t('events.modal.job') }}
                                <b-form-input :state="validateState('printTickets.printName')"
                                              :class="{'is-invalid': veeErrors.has('printTickets.printName')}"
                                              v-validate="'required|min:3'" v-model="printTickets.name" id="printName" ref="printName" type="text" size="md" name="printName"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('printTickets.printName') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-for="printerID"> {{ $t('events.modal.id') }}
                                <b-form-input :state="validateState('printTickets.printerID')"
                                              :class="{'is-invalid': veeErrors.has('printTickets.printerID')}"
                                              v-validate="'required|min_value:1'" v-model="printTickets.printer_id" id="printerID" ref="printerID" type="number" size="md" name="printerID"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('printTickets.printerID') }}</span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group label-for="printAmount"> {{ $t('events.modal.to_print') }}
                                <b-form-input :state="validateState('printTickets.printAmount')"
                                              :class="{'is-invalid': veeErrors.has('printTickets.printAmount')}"
                                              v-validate="`required|max_value:${this.printableTickets}|min_value:1`" v-model="printTickets.amount" id="printAmount"
                                              ref="printAmount" type="number" size="md" name="printAmount" required></b-form-input>
                                <span class="vvError">{{ veeErrors.first('printTickets.printAmount') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <p>
                                {{ $t('events.modal.available') }}:
                            </p>
                            <p class="text-center">
                                {{printableTickets}}
                            </p>
                        </b-col>
                    </b-row>
                    <b-row class="float-right">
                        <!-- <b-button :href="'/static/' + event.id + '.csv'" type="button" variant="success" class="mx-2" @click="setSold()"><span class="fas fa-download mx-2"></span>{{ $t('event.modal.buttons.down') }}</b-button> -->
                        <b-button type="submit" variant="primary" :disabled="veeErrors.any('printTickets')"><span class="fa fa-print mx-2"></span>{{ $t('event.modal.buttons.submit') }}</b-button>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal>
    </b-container>
</template>

<script>
    // @ is an alias to /src
    export default {
        name: 'event',
        data() {
            return {
                event: {},
                msg: ('toast.print'),
                printError: ('toast.printError'),
                down:('toast.down'),
                tickets:{
                    type: "1",
                    sector: null,
                    amount: 1,
                },
                ticketCodes: null,
                generatedTickets: {},
                printableTickets: 0,
                printTickets: {
                    printer_id: 1,
                    amount: 0,
                },
                printJobs: null,
                printJobFields: [
                    {
                        key: 'name',
                        labelPath: 'table.print.name',
                        sortable: true
                    },
                    {
                        key: 'total_printed',
                        labelPath: 'table.print.printed',
                        sortable: true
                    },
                    {
                        key: 'total',
                        labelPath: 'table.print.total',
                        sortable: true
                    },
                ],
                generateSectors: [],
                sectors: null,
                selectedGroups: [],
                sectorsString: '',
            }
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            setSold(){
                 this.$axios.post('printJobs/downloadSetPrinted', {
                        params: {
                            event: this.event,
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.show(this.$t(this.down));
                }
                });
            },
            editEvent(){
                this.$axios.post('events/updateById',
                    this.event
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$root.$emit('bv::hide::modal', 'editEvent', '#btnEdit');
                    }
                });
            },
            deleteEvent(){
                this.$axios.post('events/deleteById',{
                        params: {
                            id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.global.success({
                            message : this.$t(response.data.data.msg)
                        });
                        this.$router.push('/')
                    }else{
                        this.$toasted.global.err({
                            message : this.$t(response.data.data.msg)
                        });
                    }
                });
            },
            sectorsArrayToString(){
                let self=this;
                this.generateSectors.forEach(function(item){
                    if(item.selected){
                        self.sectorsString += item.id + ',';
                    }
                });
                this.sectorsString = this.sectorsString.substring(0, this.sectorsString.length - 1)
            },
             addSector(sector){
                sector.selected = true;
            },
            removeSector(sector){
                sector.selected = false;
            },
            generateTickets(){
                this.sectorsArrayToString();
            
                this.$validator.validateAll('generateTickets').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                             message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('events/generateTickets', {
                                params: {
                                    event: this.event,
                                    tickets: this.tickets,
                                    sectors: this.sectorsString
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.generatedTickets = response.data.data;
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                                this.sectorsString = '';
                                this.getTicketGenerateSectors();
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            getPrintJobs(){
                this.$axios.get('/printJobs/getByEventID',
                    {
                        params: {
                            id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.printJobs = response.data.data;
                    }
                })
            },
            getPrintableTickets(){
                this.$axios.get('/events/printableTickets',
                    {
                        params: {
                            id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.status === 200) {
                        this.printableTickets = response.data.data.tickets_amount;
                    }
                })
            },
            getTicketCodes(){
                this.$axios.get('/events/ticketCodes',
                    {
                        params: {
                            id: this.$route.params.id,
                        }
                    }
                ).then(response => {
                    if (response.data.success) {
                        this.ticketCodes = response.data.data;
                    }
                })
            },
            testPrint(){
                this.$axios.post('printJobs/testPrint', {
                        params: {
                            event: this.event,
                        }
                    }
                ).then(response => {
                    if(response.data.success) {
                        this.$toasted.show(this.$t(this.msg));
                    }
                });
            },
            ticketsPrint(){
                this.$validator.validateAll('printTickets').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('printJobs/printTickets', {
                                params: {
                                    event: this.event,
                                    printTickets: this.printTickets
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.printTickets = response.data.data;
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            getSectors(){
                this.$axios.get('sectors').then(response => {
                    if (response.status === 200) {
                        this.sectors = response.data.data;
                    }
                })
            },
            getTicketGenerateSectors(){
                this.$axios.get('sectors/withoutTickets', {
                    params: {
                        id: this.$route.params.id,
                    }
                }).then(response => {
                    if (response.status === 200) {
                        response.data.data.forEach(function(item){
                            item.selected = false;
                        });
                        this.generateSectors = response.data.data;
                    }
                })
            },
            getSelectedPrepaidGroups(){
                this.$axios.get('events/getPrepaidById',
                    {
                        params: {
                            id: this.$route.params.id,
                        }
                    }).then(response => {
                    if (response.status === 200) {
                        this.selectedGroups = response.data.data;
                    }
                })
            },
        },
        created() {
            this.$axios.get('/events/getById',
                {
                    params: {
                        id: this.$route.params.id,
                    }
                }
            ).then(response => {
                if (response.status === 200) {
                    this.event = response.data.data;
                }
            });
            let self = this;
            this.getPrintableTickets();
            this.getTicketGenerateSectors();
            this.getPrintJobs();
            this.getTicketCodes();
            this.getSelectedPrepaidGroups();
            this.interval = setInterval(function () {
                self.getPrintableTickets();
                self.getPrintJobs();
                self.getTicketCodes();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>